import React from 'react';
import {Alert, Box, Grid, List, ListItem, Typography} from '@deere/fuel-react';
import AccordionDetails from "@material-ui/core/AccordionDetails";
import {toCapitalize} from "../shared/utils";

export const SummaryGeneralCommentsDetails = ({classes, category, details}) => {
    const isComments = details && details.filter(ele => {
        return ele.comments.filter(comment => comment.categoryId === category).length !== 0
    })
    return <AccordionDetails className={classes.accordionDetails}>
        {isComments.length === 0 ?
            <Grid container alignItems="center">
                <Grid item xs={12}>
                    <Box style={{backgroundColor: '#f7f7f7'}}>
                        <Alert color="tertiary" style={{opacity: '0.5', color: '#666666'}}
                               variant={"info"}>No Comments</Alert>
                    </Box>
                </Grid>
            </Grid>
            :
            <List disablePadding component="nav" aria-label="stakeholder card" className={classes.root}>
                {details && details.map((item, index) => {
                    const rolesArr = item.roles.map(item => item.description)
                    const unitsArr = item.units.map(item => `${item.description} - ${item.id}`)
                    const commentData = item.comments.filter(comment => comment.categoryId === category)
                    return (
                        <React.Fragment key={index}>
                            {commentData.length !== 0 &&
                            <ListItem style={{borderBottom: "1px solid #ccc", padding: ".75rem"}} key={index}>
                                <Grid container alignItems="center">
                                    <Grid item xs={12}>
                                        <Typography variant="label">
                                            {commentData[0].comment}
                                        </Typography>
                                    </Grid>
                                    <Grid item xs={12} md={9}>
                                        <Typography color="secondary" size="sm">
                                            {toCapitalize(item.user.firstName)} {toCapitalize(item.user.lastName)} | {rolesArr.join(', ')}
                                        </Typography>
                                    </Grid>
                                    <Grid item xs={12} md={3}>
                                        <Box display="flex" justifyContent="flex-end">
                                            <Typography color="secondary" size="sm">
                                                {unitsArr.join(', ')}
                                            </Typography>
                                        </Box>
                                    </Grid>
                                </Grid>
                            </ListItem>
                            }
                        </React.Fragment>
                    )
                })}
            </List>
        }
    </AccordionDetails>;
}
